<template>
  <div class="fin-step-by-step-carousel-answers">
    <fin-scroll-carousel :items="selections"
                         :selected="value"
    >
      <template #default="{item}">
        <div>
          <v-card :class="{'btn-choice fill-height'  : true, selected: value === item.id}"
                  :style="{width: carouselItemWidth + 'px'}"
                  @mouseleave="hoverIndex = -1"
                  @mouseover="hoverIndex = item.id"
                  @mouseover.native="hoverIndex = item.id"
                  @mouseleave.native="hoverIndex = -1"
                  @click.prevent="()=>onCardClick(item.id)">
            <v-icon v-if="value === item.id"
                    class="icon-check"
                    style="color: white; background-color: #02073a; border-radius: 50%; position: absolute; right: -10px; top:-14px; font-size: 22px; padding: 3px;"></v-icon>
            <v-row
              align="center"
            >
              <v-col class="pa-2">
                <v-scale-transition>
                  <div class="card-content pa-4">
                    <background>
                      <template #g>
                        <foreignObject :key="'svg_'+(item.id)"
                                       v-bind="item.animation.svgMobiles"
                                       class="foreignObject">
                          <fin-lottie-switch
                            :animate="value === item.id || hoverIndex === item.id"
                            :options="{animationData: item.animation.animationData, autoplay: value === item.id}"/>
                        </foreignObject>
                      </template>
                    </background>
                    <p class="answer-title mb-2">{{ item.answer.title }}</p>
                    <p class="answer-info mb-2">{{ item.answer.tooltip.text }}</p>
                  </div>
                </v-scale-transition>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </template>
    </fin-scroll-carousel>
  </div>
</template>

<script>
import FinLottieSwitch from "../LottieSwitch/index"
import Background from './Background'
import FinScrollCarousel from "@/components/common/ScrollCarousel"

export default {
  name: 'fin-step-by-step-carousel-answers',
  components: {
    FinScrollCarousel,
    FinLottieSwitch, Background
  },
  data() {
    return {
      hoverIndex: -1,
      itemSize: 324,
      height: 250,
    }
  },
  props: {
    value: {
      type: Number
    },
    answers: {
      type: Array
    },
    animations: {
      type: Array
    }
  },
  methods: {
    onCardClick(n) {
      this.$emit('input', n)
    }
  },
  computed: {
    selections() {
      return this.answers.map((answer, index) => ({answer, animation: this.animations[index], id: index}))
    },
    carouselItemWidth() {
      return 275
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../../../styles/variables.scss";

.answer-title {
  font-size: 1.1em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}

.answer-info {
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 19.6px;
  letter-spacing: normal;
}

.btn-choice {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  border: 2px solid transparent;

  &:hover {
    box-shadow: $fin-color-card-shadow;
    -webkit-box-shadow: $fin-color-card-shadow;
    border: 2px solid rgba(2, 7, 58, 0.05) !important;
  }

  &.selected {
    border: 3px solid $fin-color-primary-dark !important;

    .v-icon {
      display: flex;
    }

  }

  p {
    font-size: 16px;
  }

}


/* https://github.com/vuetifyjs/vuetify/issues/10673 */
::v-deep .v-slide-group__wrapper {
  touch-action: pan-y !important;
}
</style>
